import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["chart"]

  static values = {
    series: { type: Array },
    categories: { type: Array },
    colors: { type: Array },
  }

  connect() {
    const options = {
      series: this.seriesValue,
      chart: {
        type: "bar",
        height: "350px",
        stacked: true,
        fontFamily: "Inter, sans-serif",
        toolbar: { show: false },
      },
      colors: this.colorsValue,
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        type: "category",
        categories: this.categoriesValue,
        labels: {
          style: {
            fontFamily: "Inter, sans-serif",
            cssClass: "text-xs font-normal fill-gray-500 dark:fill-gray-400",
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          style: {
            fontFamily: "Inter, sans-serif",
            cssClass: "text-xs font-normal fill-gray-500 dark:fill-gray-400",
          },
        },
      },
      legend: {
        show: true,
        position: "bottom",
        labels: { useSeriesColors: true },
      },
      tooltip: {
        shared: true,
        intersect: false,
        style: { fontFamily: "Inter, sans-serif" },
      },
      fill: { opacity: 1 },
      grid: {
        show: true,
        strokeDashArray: 4,
        padding: { left: 2, right: 2, top: -14 },
      },
    }

    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }

  disconnect() {
    this.chart.destroy()
  }
}
